var map = {
	"./admin.en.json": 5361,
	"./admin.hu.json": 7201,
	"./details.en.json": 6226,
	"./details.hu.json": 3030,
	"./doctor.en.json": 7335,
	"./doctor.hu.json": 1699,
	"./entities.en.json": 6583,
	"./entities.hu.json": 3923,
	"./journey.en.json": 6568,
	"./journey.hu.json": 8832,
	"./parameters.en.json": 726,
	"./parameters.hu.json": 7778,
	"./patient.en.json": 7027,
	"./patient.hu.json": 9399
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3678;